import type { DatePresetKey } from "#app/lib/utils/date-presets";

/**
 * How each preset reads as a trailing phrase: "No projects <phrase>", "1,204
 * stage moves <phrase>". `all-time` has no phrase — nothing is outside it, so
 * copy on that window can neither point at a wider one nor qualify a count.
 */
const WINDOW_PHRASE: Record<DatePresetKey, string | null> = {
  "all-time": null,
  today: "today",
  yesterday: "yesterday",
  "this-week": "this week",
  "last-week": "last week",
  mtd: "this month",
  "last-month": "last month",
  ytd: "this year",
  custom: "in this date range",
};

export function windowPhrase(key: DatePresetKey): string | null {
  return WINDOW_PHRASE[key];
}

/**
 * The empty-state line for one window, and the whole empty state's copy —
 * naming the window IS the instruction, so there is no second line under it.
 * `subject` is the absence with no window attached — "No projects", "No
 * activity", "No stage moves". On `all-time` the absence is total, so the
 * subject stands alone.
 */
export function windowEmptyTitle(subject: string, key: DatePresetKey): string {
  const phrase = windowPhrase(key);
  return phrase ? `${subject} ${phrase}` : subject;
}
